export default __webpack_public_path__ + "static/media/remove.2b17f56a.svg";